var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"props":_vm.props},on:{"change":_vm.handelChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }